import React from "react";
import axios from "axios";
import Select from "react-select";
import HOST_URL from "../../../configs/api";
import toastMessage from "../../../components/toastMessage";
import { Loading } from "../../../components/Loader";

class DualCustody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: [],
      appid: null,
      isLoading: false,
      isSaving: false,
      isToggling: false,
      dual_custody_enabled: false,
      maker: null,
      authoriser: null,
    };
  }

  componentDidMount() {
    this._initApps(this.props.apps);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.apps !== this.props.apps && this.props.apps.length > 0 && this.state.apps.length === 0) {
      this._initApps(this.props.apps);
    }
  }

  _initApps(apps) {
    const f_apps = apps.map((a) => ({ label: a.label || a.name, value: a.value || a._id }));
    this.setState({ apps: f_apps }, () => {
      if (f_apps.length === 1) this.onChangeSacco(f_apps[0]);
    });
  }

  onChangeSacco = (opt) => {
    this.setState({ appid: opt, maker: null, authoriser: null }, () => this.fetchConfig());
  };

  fetchConfig = () => {
    const { appid } = this.state;
    if (!appid?.value) return;
    this.setState({ isLoading: true });

    axios({
      method: "GET",
      url: `${HOST_URL.url}/dual-custody`,
      params: { app_id: appid.value },
      headers: { authorization: `Bearer ${this.props.ztoken}` },
    })
      .then(({ data }) => {
        const maker = data.users?.find((u) => u.role === "maker") || null;
        const authoriser = data.users?.find((u) => u.role === "checker") || null;
        this.setState({ isLoading: false, dual_custody_enabled: data.dual_custody_enabled, maker, authoriser });
      })
      .catch(() => {
        this.setState({ isLoading: false });
        toastMessage("error", "Failed to load dual custody settings");
      });
  };

  toggleEnabled = () => {
    const { appid, dual_custody_enabled, isSaving } = this.state;
    if (!appid?.value || isSaving) return;
    this.setState({ isSaving: true });

    axios({
      method: "PATCH",
      url: `${HOST_URL.url}/dual-custody/enable`,
      data: { app_id: appid.value, enabled: !dual_custody_enabled },
      headers: { authorization: `Bearer ${this.props.ztoken}` },
    })
      .then(() => {
        this.setState({ dual_custody_enabled: !dual_custody_enabled, isSaving: false });
        toastMessage("success", `Dual custody ${!dual_custody_enabled ? "enabled" : "disabled"}`);
      })
      .catch(() => {
        this.setState({ isSaving: false });
        toastMessage("error", "Failed to update dual custody");
      });
  };

  toggleMaker = (active) => {
    const { appid, maker, isToggling } = this.state;
    if (!maker || isToggling) return;
    this.setState({ isToggling: true });

    axios({
      method: "PATCH",
      url: `${HOST_URL.url}/dual-custody/toggle-maker`,
      data: { app_id: appid.value, user_id: maker.user_id, active },
      headers: { authorization: `Bearer ${this.props.ztoken}` },
    })
      .then(() => {
        this.setState((s) => ({ isToggling: false, maker: { ...s.maker, active } }));
        toastMessage("success", `Drafter ${active ? "activated" : "deactivated"}`);
      })
      .catch((err) => {
        this.setState({ isToggling: false });
        toastMessage("error", err?.response?.data?.message || "Failed to update drafter status");
      });
  };

  renderToggle(isOn, onToggle, isLoading) {
    return (
      <div
        onClick={isLoading ? undefined : onToggle}
        style={{
          ...styles.toggle,
          cursor: isLoading ? "not-allowed" : "pointer",
          opacity: isLoading ? 0.6 : 1,
        }}
      >
        <div style={{
          ...styles.toggleOption,
          background: !isOn ? "#64748b" : "transparent",
          color: !isOn ? "#fff" : "#94a3b8",
        }}>
          {isLoading && !isOn ? <i className="fa fa-spinner fa-spin" style={{ marginRight: 4 }}></i> : null}
          Inactive
        </div>
        <div style={{
          ...styles.toggleOption,
          background: isOn ? "#EF404F" : "transparent",
          color: isOn ? "#fff" : "#94a3b8",
        }}>
          {isLoading && isOn ? <i className="fa fa-spinner fa-spin" style={{ marginRight: 4 }}></i> : null}
          Active
        </div>
      </div>
    );
  }

  render() {
    const {
      apps, appid, isLoading, isSaving, isToggling,
      dual_custody_enabled, maker, authoriser,
    } = this.state;

    const accounts = [
      { label: "Drafter", user: maker, pillBg: "#eff6ff", pillColor: "#3b82f6", icon: "fa-pencil" },
      { label: "Authoriser", user: authoriser, pillBg: "#f0fdf4", pillColor: "#16a34a", icon: "fa-check-circle" },
    ];

    return (
      <div className="col-md-12" style={{ paddingTop: 16 }}>

        {/* Header card */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={{ flex: 1 }}>
              <h4 style={styles.cardTitle}>Dual Custody</h4>
              <div style={{ marginTop: 10, maxWidth: 320 }}>
                <label style={styles.label}>Select SACCO</label>
                <Select
                  options={apps}
                  value={appid}
                  onChange={this.onChangeSacco}
                  placeholder="Select SACCO..."
                />
              </div>
            </div>
            {appid?.value && !isLoading && (
              <div style={{ flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
                <span style={styles.toggleLabel}>Dual Custody</span>
                {this.renderToggle(dual_custody_enabled, this.toggleEnabled, isSaving)}
              </div>
            )}
          </div>
        </div>

        {!appid?.value ? (
          <div style={styles.empty}>
            <i className="fa fa-lock" style={{ fontSize: 32, color: "#cbd5e1" }}></i>
            <p style={{ marginTop: 12, color: "#94a3b8" }}>Select a SACCO to manage dual custody</p>
          </div>
        ) : isLoading ? (
          <Loading message="Loading..." icon="fa fa-spinner fa-spin" />
        ) : (
          <>
            {/* Role cards */}
            <div style={{ display: "flex", gap: 16, marginBottom: 16, flexWrap: "wrap" }}>

              {/* Drafter card */}
              <div style={{ ...styles.card, flex: 1, minWidth: 240, marginBottom: 0 }}>
                <div style={styles.roleHeader}>
                  <span style={{ ...styles.rolePill, background: "#eff6ff", color: "#3b82f6" }}>
                    <i className="fa fa-pencil" style={{ marginRight: 5 }}></i> Drafter
                  </span>
                </div>
                {maker ? (
                  <>
                    <p style={styles.userName}>{maker.user_name || maker.user_id}</p>
                    <p style={styles.userSub}>{maker.phone_number || maker.user_id}</p>
                    <div style={{ marginTop: 14 }}>
                      <label style={{ ...styles.label, marginBottom: 6 }}>Status</label>
                      {this.renderToggle(maker.active, () => this.toggleMaker(!maker.active), isToggling)}
                    </div>
                  </>
                ) : (
                  <p style={styles.unassigned}>No drafter assigned</p>
                )}
              </div>

              {/* Authoriser card */}
              <div style={{ ...styles.card, flex: 1, minWidth: 240, marginBottom: 0 }}>
                <div style={styles.roleHeader}>
                  <span style={{ ...styles.rolePill, background: "#f0fdf4", color: "#16a34a" }}>
                    <i className="fa fa-check-circle" style={{ marginRight: 5 }}></i> Authoriser
                  </span>
                  {authoriser && (
                    <span style={{ ...styles.statusDot, background: "#16a34a" }} title="Active"></span>
                  )}
                </div>
                {authoriser ? (
                  <>
                    <p style={styles.userName}>{authoriser.user_name || authoriser.user_id}</p>
                    <p style={styles.userSub}>{authoriser.phone_number || authoriser.user_id}</p>
                  </>
                ) : (
                  <p style={styles.unassigned}>No authoriser assigned</p>
                )}
              </div>
            </div>

            {/* Access Configuration */}
            <div style={{ ...styles.card, marginTop: 16 }}>
              <h4 style={styles.cardTitle}>Access Configuration</h4>
              <p style={styles.configSubtitle}>System accounts assigned to this SACCO's dual custody workflow.</p>
              <div style={{ marginTop: 14 }}>
                {accounts.map(({ label, user, pillBg, pillColor, icon }) => (
                  <div key={label} style={styles.accountRow}>
                    <span style={{ ...styles.rolePill, background: pillBg, color: pillColor, minWidth: 100 }}>
                      <i className={`fa ${icon}`} style={{ marginRight: 5 }}></i>{label}
                    </span>
                    <div style={styles.accountInfo}>
                      <span style={styles.accountName}>
                        {user ? (user.user_name || user.user_id) : <em style={{ color: "#94a3b8" }}>Not assigned</em>}
                      </span>
                      {user?.phone_number && (
                        <span style={styles.accountPhone}>{user.phone_number}</span>
                      )}
                    </div>
                    <span style={{
                      ...styles.statusBadge,
                      background: user ? "#f0fdf4" : "#f8fafc",
                      color: user ? "#16a34a" : "#94a3b8",
                    }}>
                      {user ? "Configured" : "Pending"}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const styles = {
  card: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 10,
    padding: "18px 20px",
    marginBottom: 16,
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 12,
  },
  cardTitle: {
    margin: "0 0 4px",
    fontSize: 15,
    fontWeight: 700,
    color: "#0f172a",
  },
  configSubtitle: {
    margin: "4px 0 0",
    fontSize: 12,
    color: "#94a3b8",
  },
  toggleLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
  },
  toggle: {
    display: "inline-flex",
    border: "1px solid #e2e8f0",
    borderRadius: 20,
    overflow: "hidden",
    userSelect: "none",
  },
  toggleOption: {
    padding: "5px 16px",
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 20,
    transition: "background 0.2s, color 0.2s",
    display: "flex",
    alignItems: "center",
  },
  roleHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  rolePill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "3px 12px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 700,
  },
  statusDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    display: "inline-block",
  },
  userName: {
    margin: "0 0 2px",
    fontWeight: 600,
    fontSize: 14,
    color: "#0f172a",
  },
  userSub: {
    margin: 0,
    fontSize: 12,
    color: "#64748b",
  },
  unassigned: {
    color: "#94a3b8",
    fontSize: 13,
    fontStyle: "italic",
    margin: "8px 0 0",
  },
  label: {
    display: "block",
    fontSize: 12,
    fontWeight: 600,
    color: "#374151",
    marginBottom: 4,
  },
  empty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "48px 0",
    color: "#94a3b8",
  },
  accountRow: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "10px 0",
    borderBottom: "1px solid #f1f5f9",
  },
  accountInfo: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  accountName: {
    fontSize: 13,
    fontWeight: 600,
    color: "#0f172a",
  },
  accountPhone: {
    fontSize: 11,
    color: "#94a3b8",
  },
  statusBadge: {
    fontSize: 11,
    fontWeight: 600,
    padding: "2px 10px",
    borderRadius: 20,
  },
};

export default DualCustody;
